import { render, staticRenderFns } from "./dailyPaper.vue?vue&type=template&id=03d45c4a&scoped=true"
import script from "./dailyPaper.vue?vue&type=script&lang=js"
export * from "./dailyPaper.vue?vue&type=script&lang=js"
import style0 from "./dailyPaper.vue?vue&type=style&index=0&id=03d45c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d45c4a",
  null
  
)

export default component.exports